import { __require as requireToPrimitive } from './node_modules-core-js-internals-to-primitive.js';
import { __require as requireIsSymbol } from './node_modules-core-js-internals-is-symbol.js';

var toPropertyKey;
var hasRequiredToPropertyKey;

function requireToPropertyKey () {
	if (hasRequiredToPropertyKey) return toPropertyKey;
	hasRequiredToPropertyKey = 1;
	var toPrimitive = requireToPrimitive();
	var isSymbol = requireIsSymbol();

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	toPropertyKey = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};
	return toPropertyKey;
}

export { requireToPropertyKey as __require };
//# sourceMappingURL=node_modules-core-js-internals-to-property-key.js.map
